import React, { Component } from "react";
import config from 'react-global-configuration';
import jwt_decode from "jwt-decode";
import axios from "axios";
import { connect } from "react-redux";
import { BeatLoader } from "react-spinners";
import SingleCsvReportDownload from "../components/DownloadReport/SingleCsvReportDownload.jsx";
import LastRefresh from './LastRefresh.jsx';
import {
    PURPLE, DARK_ROW,
    GREEN_TXT, ORANGE_TXT, RED_TXT,
    HEADER_TH, SUB_HEADER_TH, DATA_TD, TEXT_TD, GROUP_TD,
    spinnerOverride as override
} from './reportConstants';

// Generic lead/team performance report. Driven by the `team` prop so the same
// component renders every dashboard the Flask /lead_performance endpoint serves
// (MOT-ENT, MOT-RET, ...). The month columns and colours are entirely
// data-driven from the API response, so new months appear automatically.
class MOTPerformanceReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: null,
            error: null,
            expandedLead: true,
        };
    }

    get team() {
        return this.props.team || 'MOT-ENT';
    }

    get title() {
        return this.props.title || 'MOT Enterprise Performance Report';
    }

    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id: decoded._id,
            object_type: decoded.object_type,
        });
    }

    componentDidMount() {
        this.get_report();
    }

    componentDidUpdate(prevProps) {
        // Re-fetch when the same component instance is reused for a different team.
        if (prevProps.team !== this.props.team) {
            this.get_report();
        }
    }

    get_report() {
        this.setState({ loading: true, error: null });
        axios.post(config.get('API_URL') + '/InternalReport/lead-performance',
            { team: this.team, download: 0 },
            { headers: { Authorization: localStorage.usertoken } }
        )
        .then(response => {
            const data = response.data && response.data.data ? response.data.data : null;
            this.setState({
                data,
                loading: false,
                error: data ? null : "No data available",
                expandedLead: true,
            });
        })
        .catch(error => {
            console.error("Lead performance API error:", error);
            this.setState({ loading: false, error: "Failed to load data" });
        });
    }

    toggleLead = () => {
        this.setState(prevState => ({ expandedLead: !prevState.expandedLead }));
    }

    // Export the current dashboard as CSV. Reuses the shared report-download
    // pipeline (node /reports/report-csv-download -> Flask) with download=1.
    handleDownload = () => {
        if (!this.state.data) return;
        this.refs.csvDownload.downLoadReport(
            { team: this.team, download: 1 },
            '/service_reports/lead_performance',
            `${this.team.toLowerCase()}_performance`,
            '90'
        );
    }

    // The API ships the cell colour (e.g. '#FFCCCC'); pick a matching text colour.
    apiColorStyle(hex) {
        if (!hex) return { backgroundColor: 'transparent', color: '#333' };
        const h = hex.toUpperCase();
        if (h === '#FFCCCC' || h === '#FFE2E2') return { backgroundColor: hex, color: RED_TXT };
        if (h === '#CCFFCC' || h === '#DCFCE7') return { backgroundColor: hex, color: GREEN_TXT };
        if (h === '#FFFFCC' || h === '#FFEBD5') return { backgroundColor: hex, color: ORANGE_TXT };
        return { backgroundColor: hex, color: '#333' };
    }

    fmtNum(v) {
        if (v === null || v === undefined || v === '') return '-';
        if (typeof v === 'number') return Number.isInteger(v) ? String(v) : v.toFixed(2);
        return v;
    }

    // Build a { label -> entry } lookup so we can render in the report's month order.
    byLabel(arr) {
        const map = {};
        (arr || []).forEach(item => { map[item.label] = item; });
        return map;
    }

    shell(children) {
        const data = this.state.data;
        const title = (data && data.labels && data.labels.report_title) || this.title;
        return (
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row"><div className="col-md-12"><div className="card">
                        <div className="col-md-9 no-padd">
                            <div className="header"><h4 className="title">{title}</h4><LastRefresh /></div>
                        </div>
                        <div className="col-md-3 pull-right">
                            <div className="r-p-menu">
                                <div className="report-header-icons">
                                    <div className="icon-button download-icon" title="Download Report"
                                        style={{ cursor: 'pointer' }} onClick={this.handleDownload}>
                                        <i className="fa fa-download"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="clearfix"></div>
                        {children}
                        <div className="footer"><div className="stats"><i></i></div></div>
                        <SingleCsvReportDownload ref="csvDownload" />
                    </div></div></div>
                </div>
            </div>
        );
    }

    render() {
        const { loading, error, data } = this.state;

        if (loading) {
            return this.shell(
                <div className="content"><BeatLoader css={override} size={15} color={"#51bcda"} loading={loading} /></div>
            );
        }
        if (error || !data) {
            return this.shell(
                <div className="content"><div className="alert alert-danger">{error || "No data available"}</div></div>
            );
        }

        const months = data.months || [];
        const labels = data.labels || {};
        const leadByMonth = this.byLabel(data.lead_summary_by_month);
        const isExpanded = this.state.expandedLead;

        const nameColPct = 20;
        const dataColPct = parseFloat(((100 - nameColPct) / (months.length * 2)).toFixed(4));

        return this.shell(
            <>
                <div className="content">
                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                        <table className="table" style={{ borderCollapse: 'separate', borderSpacing: 0, width: '100%', tableLayout: 'fixed' }}>
                            <colgroup>
                                <col style={{ width: `${nameColPct}%` }} />
                                {months.map((_, i) => <col key={`cl${i}`} style={{ width: `${dataColPct}%` }} />)}
                                {months.map((_, i) => <col key={`cr${i}`} style={{ width: `${dataColPct}%` }} />)}
                            </colgroup>
                            <thead>
                                <tr style={{ backgroundColor: PURPLE, color: 'white' }}>
                                    <th rowSpan={2} style={HEADER_TH}>{labels.lead_col_header || 'MOT Lead Name'}</th>
                                    <th colSpan={months.length} style={HEADER_TH}>{labels.left_section_header || 'Count of agents not meeting minimum target for getting incentive in the month'}</th>
                                    <th colSpan={months.length} style={HEADER_TH}>{labels.right_section_header || 'Average cost per MOT ticket that passes QC'}</th>
                                </tr>
                                <tr style={{ backgroundColor: '#fff' }}>
                                    {months.map(m => <th key={`lmiss-${m}`} style={SUB_HEADER_TH}>{m}</th>)}
                                    {months.map(m => <th key={`lcost-${m}`} style={SUB_HEADER_TH}>{m}</th>)}
                                </tr>
                            </thead>
                            <tbody>
                                <tr style={{ backgroundColor: DARK_ROW, cursor: 'pointer' }} onClick={this.toggleLead}>
                                    <td style={GROUP_TD}>
                                        <span style={{ marginRight: '10px' }}>{isExpanded ? '▼' : '▶'}</span>
                                        {data.lead_name} ({data.total_agents} MOT Agents)
                                    </td>
                                    {months.map(m => {
                                        const e = leadByMonth[m] || {};
                                        return (
                                            <td key={`lmiss-${m}`} style={{ ...DATA_TD, ...this.apiColorStyle(e.agents_not_meeting_color) }}>
                                                {this.fmtNum(e.agents_not_meeting_threshold)}
                                            </td>
                                        );
                                    })}
                                    {months.map(m => {
                                        const e = leadByMonth[m] || {};
                                        return (
                                            <td key={`lcost-${m}`} style={{ ...DATA_TD, ...this.apiColorStyle(e.avg_cost_color) }}>
                                                {this.fmtNum(e.avg_cost_per_ticket)}
                                            </td>
                                        );
                                    })}
                                </tr>

                                {isExpanded && (
                                    <>
                                        <tr style={{ backgroundColor: PURPLE, color: 'white' }}>
                                            <th rowSpan={2} style={HEADER_TH}>{labels.agent_col_header || 'MOT Agent Name'}</th>
                                            <th colSpan={months.length} style={HEADER_TH}>{labels.productivity_col_header || 'Average # of tickets that pass QC per hour'}</th>
                                            <th colSpan={months.length} style={HEADER_TH}>{labels.avg_cost_col_header || 'Avg cost passing QC per hour'}</th>
                                        </tr>
                                        <tr style={{ backgroundColor: '#fff' }}>
                                            {months.map(m => <th key={`aprod-${m}`} style={SUB_HEADER_TH}>{m}</th>)}
                                            {months.map(m => <th key={`acost-${m}`} style={SUB_HEADER_TH}>{m}</th>)}
                                        </tr>
                                        {(data.agents || []).map((ag, aIdx) => {
                                            const agByMonth = this.byLabel(ag.months);
                                            return (
                                                <tr key={aIdx} style={{ backgroundColor: '#fff' }}>
                                                    <td style={TEXT_TD}><strong>{ag.agent_name}</strong></td>
                                                    {months.map(m => {
                                                        const e = agByMonth[m] || {};
                                                        return (
                                                            <td key={`aprod-${m}`} style={{ ...DATA_TD, ...this.apiColorStyle(e.productivity_color) }}>
                                                                {this.fmtNum(e.productivity)}
                                                            </td>
                                                        );
                                                    })}
                                                    {months.map(m => {
                                                        const e = agByMonth[m] || {};
                                                        return (
                                                            <td key={`acost-${m}`} style={{ ...DATA_TD, ...this.apiColorStyle(e.cost_per_ticket_color) }}>
                                                                {this.fmtNum(e.cost_per_ticket)}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            );
                                        })}
                                    </>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    currentMenu: (name) => dispatch({ type: 'change_menu', payload: name })
});

export default connect(null, mapDispatchToProps)(MOTPerformanceReport);
